<template>
  <div class="w-full">
    <router-view />
  </div>
</template>

<script>
import { state, mutations } from '../components/documents/publish/hooks/useMassivePublication'

export default {
  provide: { state, mutations }
}
</script>
